export default __webpack_public_path__ + "static-front/media/AuthorizationFon.459b9268.svg";